import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { NavigateLinks } from '@/components';
import { userHasPermission } from '@/components/security/AppRoles';
import { useUserInfo } from '@/hooks';

import MenuCard from './components/MenuCard';
import { businessPageBreadcrumbs } from './config';
import { businessMenuSections } from './config/menuSections';

export const Business = () => {
  const navigate = useNavigate();
  const { permissions } = useUserInfo();
  const breadcrumbs = useMemo(
    () => businessPageBreadcrumbs(navigate),
    [navigate]
  );

  const sections = useMemo(
    () =>
      businessMenuSections
        .map((section) => ({
          ...section,
          items: section.items.filter(
            (item) =>
              !item.permission ||
              userHasPermission(permissions, item.permission)
          ),
        }))
        .filter((section) => section.items.length > 0),
    [permissions]
  );

  return (
    <section className='w-full h-full flex flex-col gap-8 p-5'>
      <NavigateLinks actualPage='Sistema de envíos' breadcrumbs={breadcrumbs} />

      <div className='w-full max-w-[1100px] mx-auto flex flex-col gap-10'>
        {sections.map((section) => (
          <section key={section.id} className='flex flex-col gap-4'>
            <header className='flex flex-col gap-1'>
              <h2 className='text-[0.68rem] font-bold uppercase tracking-[0.08em] text-[var(--gray-color)]'>
                {section.title}
              </h2>
              <p className='text-sm text-[var(--secondary-color)] opacity-70'>
                {section.description}
              </p>
            </header>

            <ul className='grid grid-cols-[repeat(auto-fill,200px)] gap-x-[40px] gap-y-[32px] justify-start'>
              {section.items.map((item) => (
                <MenuCard
                  key={item.id}
                  label={item.label}
                  icon={item.icon}
                  alt={item.alt}
                  onClick={() => navigate(item.route)}
                  imageClassName={item.imageClassName}
                  cardClassName={item.cardClassName}
                  labelClassName={item.labelClassName}
                />
              ))}
            </ul>
          </section>
        ))}
      </div>
    </section>
  );
};
